<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" :width="width" :height="height" viewBox="0 0 300.000000 300.000000" preserveAspectRatio="xMidYMid meet">
    <g xmlns="http://www.w3.org/2000/svg" transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" :fill="iconColor" stroke="none">
      <path d="M1445 2856 c-16 -8 -123 -108 -237 -223 l-208 -209 0 -51 c0 -61 30 -105 84 -123 56 -18 85 -3 189 98 l97 96 0 -490 c0 -467 1 -490 20 -521 45 -74 139 -83 197 -19 l33 36 0 497 0 498 93 -93 c96 -96 133 -116 189 -105 62 12 111 94 93 155 -10 32 -413 437 -452 454 -40 17 -59 17 -98 0z"/>
      <path d="M932 976 c-81 -45 -81 -169 1 -213 29 -16 76 -18 532 -21 275 -2 520 0 544 3 32 5 54 16 78 40 29 29 33 39 33 85 0 46 -4 56 -34 86 l-34 34 -549 0 c-426 -1 -553 -4 -571 -14z"/>
      <path d="M194 360 c-41 -16 -74 -68 -74 -116 0 -37 6 -51 34 -82 l34 -37 1291 -3 c1405 -2 1339 -5 1377 53 23 35 22 103 -1 138 -39 60 43 57 -1357 56 -706 0 -1292 -4 -1304 -9z"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "IconExternalTransfer",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "black",
    },
  },
};
</script>
